import { IGetObraHeaderInfoUseCase } from "../../../presentation/useCases/read/get_obra_header_info_use_case";
import { ObraHeaderInfo } from "../../models/obra_header_info";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraHeaderInfoUseCase
 */

export class GetObraHeaderInfoUseCase implements IGetObraHeaderInfoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraHeaderInfo(
    idObra: number | undefined,
  ): Promise<ObraHeaderInfo> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');
    const response = await this.repository.getObraHeaderInfo(idObra);
    if (response === null) throw new Error('Falha ao buscar dados da obra!');
    return response;
  }
}
